<table
  *ngIf="jobProduced?.JobName || jobProduced?.SheetSize || jobProduced?.ProductionSpeed"
  class="ir-plugin-table"
  style="margin-bottom: 10px"
>
  <tr *ngIf="jobProduced?.JobName">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationjobproduced.job-name' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ jobProduced.JobName }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="jobProduced?.SheetSize">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationjobproduced.sheet-size' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ jobProduced.SheetSize }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="jobProduced?.ProductionSpeed">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationjobproduced.prod-speed' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ jobProduced.ProductionSpeed }}</span>
      </p>
    </td>
  </tr>
</table>
<table
  *ngIf="jobProduced?.LabelValues && jobProduced?.LabelValues.length > 0"
  class="ir-plugin-table"
  style="margin-bottom: 10px"
>
  <tr *ngFor="let item of jobProduced?.LabelValues">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <strong>
        <span>{{ item.Label | joblabel }}</span>
      </strong>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.Value }}</span>
      </p>
    </td>
  </tr>
</table>
<table *ngIf="jobProduced?.Comment" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationjobproduced.comment' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <div class="ir-plugin-values th-plugin-values angular-editor-view ir-ph1" [innerHtml]="jobProduced.Comment"></div>
    </td>
  </tr>
</table>
